import { isNumber } from 'lodash-es';

const toNumber = (i: string | number) =>
  typeof i === 'number' ? i : Number.parseInt(i, 10);

const filterByOnlyParsedNumbers = (items: (string | number)[]) =>
  items.map(toNumber).filter(isNumber);

export default filterByOnlyParsedNumbers;
